module.exports = __webpack_public_path__ + "static/media/通信+.e37f07a2.png";